import enUs from './en-us.json';

export const languageMap = {
	'en-us': enUs,
};
